export const GROUP_ID_PARAM = ":groupId";
export const PRODUCT_ID_PARAM = ":productId";

export const CREATE_PRODUCT_GROUP = "/create";
export const EDIT_PRODUCT_GROUP = `/edit/${GROUP_ID_PARAM}`;
